import { forwardRef, Ref } from 'react'
import { Loader } from 'lucide-react'

export const AppLoader = forwardRef<
  HTMLDivElement,
  { ref?: Ref<HTMLDivElement> }
>((_, ref) => {
  return (
    <div
      ref={ref}
      data-testid="app-loader"
      className="p-m absolute inset-0 z-10 flex h-full w-full justify-center"
    >
      <Loader
        className="mt-[200px] h-24 w-24 animate-spin text-gray-500"
        size="148"
      />
    </div>
  )
})

AppLoader.displayName = 'AppLoader'
